var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:("base-button base-button" + ((_vm.data.attrs && _vm.data.attrs.type) ? '-' + _vm.data.attrs.type : ''))},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }